"use client";

import { sendGTMEvent } from "@next/third-parties/google";

import { getStoredAnalyticsConsent } from "@/lib/analytics/consent";

export type TGtmEvent = Record<string, unknown> & { event: string };

/**
 * Centralized GTM event helper (privacy-gated).
 * - No events are sent until analytics consent is granted.
 * - Callers must avoid including PII unless explicitly required.
 */
export function trackGtmEvent(payload: TGtmEvent): void {
  if (getStoredAnalyticsConsent() !== "granted") return;
  sendGTMEvent(payload);
}

